import { action, payload } from 'ts-action'
import { IRoster } from 'models/Roster'
import { IError, IPayload } from 'models/Global'

export const RostersFetching = action('RostersFetching', payload<boolean>())

export const GetRosters = action('GetRosters', payload<IPayload<IRoster[]>>())

export const DeleteRoster = action('DeleteRoster', payload<number>())

export const ReorderBusinessRosters = action(
  'ReorderBusinessRosters',
  payload<{
    oldIndex: number
    newIndex: number
  }>()
)

export const GetRostersErrors = action('GetRostersErrors', payload<IError>())

export const ClearBusinessRosters = action('ClearBusinessRosters')
